module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/core-js/library/modules/_add-to-unscopables.js
// module id = ../../../../core-js/library/modules/_add-to-unscopables.js
// module chunks = 42